import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice d'absence - Calcul du pourcentage d'absence autorisé";
const DESCRIPTION =
  "Calculatrice d'absence - Calcul du pourcentage d'absence autorisé. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "absence calculator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/absence-calculator/";

function AbsenceCalculator() {
  const [numDays, setNumDays] = useState(1);
  const [hoursPerDay, setHoursPerDay] = useState([""]);
  const [numSemesters, setNumSemesters] = useState(16);
  const [allowedAbsence, setAllowedAbsence] = useState(10);
  const [totalHours, setTotalHours] = useState(0);
  const [allowedAbsenceHours, setAllowedAbsenceHours] = useState(0);
  const [estimatedAbsenceDays, setEstimatedAbsenceDays] = useState(0);
  const [error, setError] = useState("");

  const handleNumDaysChange = (e) => {
    const days = parseInt(e.target.value);
    setNumDays(days);
    setHoursPerDay(Array(days).fill(""));
  };

  const handleHoursPerDayChange = (index, value) => {
    const newHoursPerDay = [...hoursPerDay];
    newHoursPerDay[index] = value;
    setHoursPerDay(newHoursPerDay);
  };

  const handleCalculate = () => {
    try {
      const totalHoursPerWeek = hoursPerDay.reduce(
        (acc, curr) => acc + parseFloat(curr || 0),
        0
      );
      const totalHours = totalHoursPerWeek * numSemesters;
      const allowedAbsenceHours = (totalHours * allowedAbsence) / 100;
      const averageHoursPerDay = totalHoursPerWeek / numDays;
      const estimatedAbsenceDays = allowedAbsenceHours / averageHoursPerDay;

      setTotalHours(totalHours);
      setAllowedAbsenceHours(allowedAbsenceHours);
      setEstimatedAbsenceDays(estimatedAbsenceDays.toFixed(2));
      setError("");
    } catch (error) {
      setError("Une erreur s'est produite lors du calcul. Veuillez vérifier vos entrées.");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Obtenez un calcul précis du pourcentage d'absence autorisé dans votre étude!
                  Cet outil intelligent est conçu pour vous aider à déterminer le nombre de cours
                  que vous pouvez manquer sans affecter votre note finale.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group">
                    <label>Nombre de jours par semaine:</label>
                    <input type="number" value={numDays} onChange={handleNumDaysChange} className="form-control" min="1" max="7" />
                  </div>
                  {hoursPerDay.map((hours, index) => (
                    <div key={index} className="form-group">
                      <label>Heures du jour {index + 1}:</label>
                      <input type="number" value={hours} onChange={(e) => handleHoursPerDayChange(index, e.target.value)} className="form-control" placeholder="0" />
                    </div>
                  ))}
                  <div className="form-group">
                    <label>Nombre de semestres:</label>
                    <input type="number" value={numSemesters} onChange={(e) => setNumSemesters(parseInt(e.target.value))} className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Pourcentage d'absence autorisé (%):</label>
                    <input type="number" value={allowedAbsence} onChange={(e) => setAllowedAbsence(parseInt(e.target.value))} className="form-control" min="0" max="100" />
                  </div>
                  <button onClick={handleCalculate} className="btn btn-success w-100">Calculer</button>
                </div>
              </div>
              <div className="col-sm-12 col-md-5">
                {totalHours > 0 && (
                  <div className="bg-light p-3 rounded">
                    <h3>Résultats:</h3>
                    <p><strong>Total d'heures:</strong> {totalHours.toFixed(2)} heures</p>
                    <p><strong>Heures d'absence autorisées:</strong> {allowedAbsenceHours.toFixed(2)} heures</p>
                    <p><strong>Jours d'absence estimés:</strong> {estimatedAbsenceDays} jours</p>
                  </div>
                )}
                {error && <div className="alert alert-danger">{error}</div>}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment est calcule le seuil d'absence</h3></div>
              <div className="info-section-body">
                <p>L'outil additionne vos heures hebdomadaires, les projette sur la periode (semaines/semestres), puis applique le pourcentage d'absence autorise. Vous obtenez ainsi un nombre d'heures et de jours estimatifs a ne pas depasser.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Pourquoi ce calcul est utile</h3></div>
              <div className="info-section-body">
                <p>Ce repere aide a anticiper vos marges d'absence avant les examens ou stages. Il permet aussi de mieux organiser vos obligations personnelles sans risquer de depasser le seuil autorise.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Point de vigilance</h3></div>
              <div className="info-section-body">
                <p>Les regles varient selon l'etablissement: absences justifiees, retards, travaux pratiques ou controles peuvent etre comptes differemment. Utilisez ce resultat comme estimation et verifiez toujours le reglement officiel.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AbsenceCalculator;